import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch as useStoreDispatch } from "react-redux";
import auth from "./api/authSlice";
import { employeeApi } from "./api/employeeApi";
import { categoryApi } from "./api/categoryApi";
import { productsApi } from "./api/productsApi";
import { productsApiV2 } from "./api/productsApiV2";
import { printApi } from "./api/printApi";
import { printApiV2 } from "./api/printApiV2";
import { configurationApi } from "./api/configurationApi";
import { accountApi } from "./api/accountApi";
import { measurementApi } from "./api/measurementApi";
import { producerApi } from "./api/producerApi";
import { producerApiV2 } from "./api/producerApiV2";
import { printCategoryApi } from "./api/printCategoryApi";
import printReducer from "./api/printSlice";

// List reducers
export const reducer = combineReducers({
  [employeeApi.reducerPath]: employeeApi.reducer,
  [categoryApi.reducerPath]: categoryApi.reducer,
  [productsApi.reducerPath]: productsApi.reducer,
  [productsApiV2.reducerPath]: productsApiV2.reducer,
  [printApi.reducerPath]: printApi.reducer,
  [printApiV2.reducerPath]: printApiV2.reducer,
  [configurationApi.reducerPath]: configurationApi.reducer,
  [accountApi.reducerPath]: accountApi.reducer,
  [measurementApi.reducerPath]: measurementApi.reducer,
  [producerApi.reducerPath]: producerApi.reducer,
  [producerApiV2.reducerPath]: producerApiV2.reducer,
  [printCategoryApi.reducerPath]: printCategoryApi.reducer,
  auth,
  printState: printReducer, 
});

export type StoreState = ReturnType<typeof reducer>;
export type AppDispatch = typeof store.dispatch;

export const useDispatch = () => useStoreDispatch<AppDispatch>();

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ immutableCheck: false })
      .concat(employeeApi.middleware)
      .concat(categoryApi.middleware)
      .concat(productsApi.middleware)
      .concat(productsApiV2.middleware)
      .concat(printApi.middleware)
      .concat(printApiV2.middleware)
      .concat(configurationApi.middleware)
      .concat(accountApi.middleware)
      .concat(measurementApi.middleware)
      .concat(producerApi.middleware)
      .concat(producerApiV2.middleware)
      .concat(printCategoryApi.middleware),
});
